export const sortByOrderUrls = (arrayToSort, arrayToSortBy) =>
  arrayToSort?.sort(
    (a, b) =>
      arrayToSortBy.findIndex((item) => item.url === a.link) -
      arrayToSortBy.findIndex((item) => item.url === b.link)
  );
